export default "__VITE_ASSET__C9PK6Kz6__"